import type { Structure } from '../types/categories';
import { CompType } from '../types/CompType';
import { SectionItemDataType } from '../types/SectionItemDataType';
import type { PresetSectionItem, Video } from '../types/sections';
import { SourceType } from '../types/SourceType';

export class PresetSectionItemBuilder {
  private item: PresetSectionItem = {
    systemId: 'section-item-system-id',
    id: 'section-item-id',
    itemId: '',
    index: 0,
    sectionIds: [],
    sectionOverrideIds: [],
    locale: '',
    structure: {
      componentType: CompType.CustomElement,
      data: {
        freezeFrame: false,
        metaData: {
          isPreset: true,
          schemaVersion: 'v1.0',
          isHidden: false,
        },
        sourceType: SourceType.External,
        type: SectionItemDataType.TPAWidget,
        url: '',
      },
      style: '',
      styleId: '',
      design: {},
    },
    text: '',
    liveTextToShow: '',
    themeName: '',
    symbolName: '',
    className: '',
    overrideClass: '',
    appDefinitionId: '',
    preset: {
      rect: { height: 0, width: 0, x: 0, y: 0 },
      label: '',
      shape: {
        name: '',
        coords: '',
      },
      labelClasses: '',
      video: { source: '' },
      tags: null,
    },
    conditions: [],
  };

  withSystemId(id: string): this {
    this.item.systemId = id;

    return this;
  }

  withId(id: string): this {
    this.item.id = id;

    return this;
  }

  withSectionIds(ids: string[]): this {
    this.item.sectionIds = ids;

    return this;
  }

  withLocale(locale: string): this {
    this.item.locale = locale;
    return this;
  }

  withIndex(index: number): this {
    this.item.index = index;
    return this;
  }

  withLiveTextToShow(liveTextToShow: PresetSectionItem['liveTextToShow']): this {
    this.item.liveTextToShow = liveTextToShow;
    return this;
  }

  withPresetRect(rect: PresetSectionItem['preset']['rect']): this {
    this.item.preset.rect = rect;
    return this;
  }

  withStructure(structure: Structure): this {
    this.item.structure = structure;
    return this;
  }

  withStructureComponentType(componentType: CompType): this {
    this.item.structure.componentType = componentType;
    return this;
  }

  withPresetVideoSource(source: Video['source']): this {
    if (this.item.preset.video) {
      this.item.preset.video.source = source;
    }
    return this;
  }

  withPresetLabel(label: PresetSectionItem['preset']['label']): this {
    this.item.preset.label = label;
    return this;
  }

  build(): PresetSectionItem {
    return { ...this.item };
  }
}
